
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-js-8-filtering-pagination-and-sorting.json") })
        }
      }, "path---graphql-js-8-filtering-pagination-and-sorting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-js-8-filtering-pagination-and-sorting!./.cache/json/graphql-js-8-filtering-pagination-and-sorting.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-js-8-filtering-pagination-and-sorting!./.cache/json/graphql-js-8-filtering-pagination-and-sorting.json
// module chunks = 154